<template>
    <form @submit.prevent="validar" :class="cargando ? 'overlay overlay-block' : ''">
        <div class="row">
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger"></i>Relación laboral</label>
                <combo-box v-model="datos.relacion" :valid="errors.has('relación laboral')" :opciones="lsRelacion"
                           name="relación laboral"
                           v-validate="{required:true,obj:true}"></combo-box>
                <span class="form-text text-danger">{{errors.first("relación laboral")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger" v-if="mostrar"></i>Tipo actividad económica</label>
                <combo-box v-model="datos.tipoAc" :valid="errors.has('tipo de actividad económica')"
                           :disabled="!mostrar" :opciones="lsActividad" name="tipo de actividad económica"
                           v-validate="{required:mostrar,obj:mostrar}"></combo-box>
                <span class="form-text text-danger">{{errors.first("tipo de actividad económica")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger" v-if="mostrar"></i>Sector laboral</label>
                <combo-box v-model="datos.sector" :valid="errors.has('sector laboral')" :disabled="!mostrar"
                           :opciones="lsSector" name="sector laboral"
                           v-validate="{required:mostrar,obj:mostrar}"></combo-box>
                <span class="form-text text-danger">{{errors.first("sector laboral")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger" v-if="mostrar"></i>Provincia</label>
                <combo-box v-model="datos.provincia" :valid="errors.has('provincia')" :disabled="!mostrar"
                           :opciones="lsProvincias" name="provincia"
                           v-validate="{required:mostrar,obj:mostrar}"></combo-box>
                <span class="form-text text-danger">{{errors.first("provincia")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger" v-if="mostrar"></i>Ciudad</label>
                <combo-box v-model="datos.ciudad" :valid="errors.has('ciudad')" :disabled="!mostrar"
                           :opciones="lstCantones" name="ciudad"
                           v-validate="{required:mostrar,obj:mostrar}"></combo-box>
                <span class="form-text text-danger">{{errors.first("ciudad")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label for="empresa"><i class="fa fa-asterisk text-danger" v-if="mostrar"></i>Empresa</label>
                <input type="text" class="form-control" :class="errors.has('empresa') && 'is-invalid'"
                       :disabled="!mostrar" v-model="datos.empresa" id="empresa" name="empresa"
                       v-validate="{required:mostrar,max:350}">
                <span class="form-text text-danger">{{errors.first("empresa")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label for="rsocial">Razón social de la empresa</label>
                <input type="text" class="form-control" :class="errors.has('razón social') && 'is-invalid'"
                       v-validate="{max:350}" v-model="datos.razon" :disabled="!mostrar" name="razón social" id="rsocial">
                <span class="form-text text-danger">{{errors.first("razón social")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label for="cargo"><i class="fa fa-asterisk text-danger" v-if="mostrar"></i>Cargo que Desempeña</label>
                <input type="text" class="form-control" :class="errors.has('cargo') && 'is-invalid'"
                       :disabled="!mostrar" v-model="datos.cargo" name="cargo" id="cargo"
                       v-validate="{required:mostrar,max:120}">
                <span class="form-text text-danger">{{errors.first("cargo")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label for="telefonoempresa"><i class="fa fa-asterisk text-danger" v-if="mostrar && tipo.form===1"></i>Teléfono de la empresa</label>
                <input type="text" class="form-control" :class="errors.has('teléfono de la empresa') && 'is-invalid'"
                       :disabled="!mostrar" v-model="datos.telefonoE" name="teléfono de la empresa" id="telefonoempresa"
                       v-validate="{required:mostrar && tipo.form===1,...valTelf.fijo}">
                <span class="form-text text-danger">{{errors.first("teléfono de la empresa")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label for="emailempresa">Email de la empresa</label>
                <input type="email" class="form-control" :class="errors.has('email empresa') && 'is-invalid'"
                       :disabled="!mostrar" v-model="datos.emailE" name="email empresa" id="emailempresa"
                       v-validate="{email:true,max:50}">
                <span class="form-text text-danger">{{errors.first("email empresa")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label for="dirempresa"><i class="fa fa-asterisk text-danger" v-if="mostrar"></i>Dirección de la empresa</label>
                <input type="text" class="form-control" :class="errors.has('dirección de la empresa') && 'is-invalid'"
                       :disabled="!mostrar" v-model="datos.direccionE" name="dirección de la empresa" id="dirempresa"
                       v-validate="{required:mostrar,max:50}">
                <span class="form-text text-danger">{{errors.first("dirección de la empresa")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label for="añostrabajo"><i class="fa fa-asterisk text-danger" v-if="mostrar"></i>Años de trabajo en la empresa</label>
                <input type="number" class="form-control" :class="errors.has('años de trabajo') && 'is-invalid'"
                       :disabled="!mostrar" v-model="datos.anios" name="años de trabajo" id="añostrabajo"
                       v-validate="{required:mostrar,max_value:99,min_value:1,numeric:true}">
                <span class="form-text text-danger">{{errors.first("años de trabajo")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label for="mesestrabajo"><i class="fa fa-asterisk text-danger" v-if="mostrar"></i>Meses de trabajo en la empresa</label>
                <input type="number" class="form-control" :class="errors.has('meses de trabajo') && 'is-invalid'"
                       :disabled="!mostrar" v-model="datos.meses" name="meses de trabajo" id="mesestrabajo"
                       v-validate="{required:mostrar,max_value:11,numeric:true}">
                <span class="form-text text-danger">{{errors.first("meses de trabajo")}}</span>
            </div>
            <div class="col-12 col-md-12 p-1">
                <button type="submit" class="btn btn-primary btn-elevate btn-pill btn-block"
                        :class="cargando ? 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light' : ''"
                        :disabled="cargando">Guardar
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import comboBox from "../comboBox";
    import constantes from "../../constantes";
    import {persona} from "../../servicios";
    import _ from 'lodash';

    const vacio = {id: 0, dt1: null};
    const vector = ["ESTUDIANTE", "JUBILADO"];
    export default {
        name: "actividadEconomica",
        props: {
            sync: {
                type: Boolean,
                default: false,
            },
            identificador: {
                type: Number,
                required: false,
            },
            previos: {
                type: Object
            },
            formulario: {
                type: Object,
                required: true
            },
            tipo: {
                type: Object,
                required: true
            },
            lsRelacion: {
                type: Array,
                required: true
            },
            lsActividad: {
                type: Array,
                required: true
            },
            lsSector: {
                type: Array,
                required: true
            },
            lsProvincias: {
                type: Array,
                required: true
            },
            lsPais: {
                type: Array,
                required: true
            }

        },
        components: {
            comboBox
        },
        data: () => ({
            datos: {
                relacion: vacio,
                tipoAc: vacio,
                sector: vacio,
                pais: vacio,
                provincia: vacio,
                ciudad: vacio,
                empresa: null,
                cargo: null,
                telefonoE: null,
                emailE: null,
                direccionE: null,
                ruc: null,
                anios: null,
                meses: null,
                razon: null
            },
            lstCantones: [],
            lstParroquias: [],
            mostrar: true,
            cargando: false,
            valTelf: constantes.Constantes.validacion,
        }),
        methods: {
            validar: function () {
                if (this.tipo.form === 2 && !this.identificador) {
                    this.$toast.show(`Completa el formulario de Cónyuge Datos Personales`);
                    return 0;
                }
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.cargando = true;
                        this.enviarDatos();
                    } else {
                        this.$toast.show(`Completa el formulario ` + this.formulario.id + " " + this.tipo.titulo);
                        setTimeout(() => {
                            let container = this.$el.querySelector('.is-invalid');
                            container.scrollIntoView();
                        }, 100);
                    }
                });
            },
            enviarDatos: _.debounce(function () {
                persona.actualizacionLaborales(this.datos, this.tipo.form, this.identificador).then(() => {
                    this.datos.complete = true;
                    this.cargando = false;
                    this.$emit('input', this.datos);
                });
            }, 2000),
            limpiarForm: function () {
                const vm = this;
                let isObject = function (a) {
                    return (!!a) && (a.constructor === Object);
                };
                Object.keys(this.datos).forEach(function (key) {
                    if (isObject(vm.datos[key]))
                        vm.datos[key] = key !== "relacion" ? vacio : vm.datos[key];
                    else
                        vm.datos[key] = null;
                });
            }
        },
        watch: {
            "sync": function () {
                const dto = this.previos;
                if (this.tipo.form === 1 && dto.elements7.length) {
                    this.datos.relacion = constantes.funciones.buscarArrayPorId(this.lsRelacion, dto.elements7[0].ndt7);
                    this.datos.tipoAc = constantes.funciones.buscarArrayPorId(this.lsActividad, dto.elements7[0].ndt2);
                    this.datos.sector = constantes.funciones.buscarArrayPorId(this.lsSector, dto.elements7[0].ndt6);
                    this.datos.pais = constantes.funciones.buscarArrayPorId(this.lsPais, dto.elements7[0].ndt5);
                    this.datos.provincia = constantes.funciones.buscarArrayPorId(this.lsProvincias, dto.elements7[0].ndt4);
                    this.datos.empresa = dto.elements7[0].dt1;
                    this.datos.cargo = dto.elements7[0].dt2;
                    this.datos.telefonoE = dto.elements7[0].dt3;
                    this.datos.emailE = dto.elements7[0].dt4;
                    this.datos.direccionE = dto.elements7[0].dt6;
                    this.datos.ruc = dto.elements7[0].dt7;
                    this.datos.razon = dto.elements7[0].dt8;
                    this.datos.anios = dto.elements7[0].ndt8;
                    this.datos.meses = dto.elements7[0].ndt9;
                    setTimeout(() => {
                        this.datos.ciudad = constantes.funciones.buscarArrayPorId(this.datos.provincia.elements, dto.elements7[0].ndt3);
                    }, 1000);
                }
                if (this.tipo.form === 2 && dto.elements12.length) {
                    this.datos.relacion = constantes.funciones.buscarArrayPorId(this.lsRelacion, dto.elements12[0].ndt7);
                    this.datos.tipoAc = constantes.funciones.buscarArrayPorId(this.lsActividad, dto.elements12[0].ndt2);
                    this.datos.sector = constantes.funciones.buscarArrayPorId(this.lsSector, dto.elements12[0].ndt6);
                    this.datos.pais = constantes.funciones.buscarArrayPorId(this.lsPais, dto.elements12[0].ndt5);
                    this.datos.provincia = constantes.funciones.buscarArrayPorId(this.lsProvincias, dto.elements12[0].ndt4);
                    this.datos.empresa = dto.elements12[0].dt1;
                    this.datos.cargo = dto.elements12[0].dt2;
                    this.datos.telefonoE = dto.elements12[0].dt3;
                    this.datos.emailE = dto.elements12[0].dt4;
                    this.datos.direccionE = dto.elements12[0].dt6;
                    this.datos.ruc = dto.elements12[0].dt7;
                    this.datos.razon = dto.elements12[0].dt8;
                    this.datos.anios = dto.elements12[0].ndt8;
                    this.datos.meses = dto.elements12[0].ndt9;
                    setTimeout(() => {
                        this.datos.ciudad = constantes.funciones.buscarArrayPorId(this.datos.provincia.elements, dto.elements12[0].ndt3);
                    }, 1000);
                }

            },
            "datos.provincia.id": function (provincia) {
                this.lstCantones = [];
                this.parroquia = [];
                this.datos.parroquia = vacio;
                this.datos.ciudad = vacio;
                if (provincia)
                    this.lstCantones = this.lsProvincias.find(x => x.id === provincia).elements || [];
            },
            "datos.ciudad.id": function (canton) {
                this.datos.parroquia = vacio;
                this.lstParroquias = [];
                if (canton)
                    this.lstParroquias = this.lstCantones.find(x => x.id === canton).elements || [];
            },
            "datos.relacion": function (val) {
                this.mostrar = vector.indexOf(val.dt1) === -1;
                this.$validator.reset();
                if (!this.mostrar) {
                    this.limpiarForm();
                }
            }
        }
    }
</script>

<style scoped>

</style>
